import React from "react";
import styled from "styled-components";

const RequestTrackingStatusDiv = styled.div`
  & div.progressBar div.progressLine {
    display: flex;
    gap: 2px;
    width: 100%;
    & div {
      width: 100%;
      display: flex;
      background: #f7f8f9;
      align-items: center;
      justify-content: center;
      height: 25px;
    }
    & div.done {
      background: #00c457;
    }
    & div.active {
      color: #fff;
      font-weight: bold;
    }
  }
`;

const RequestTrackingStatus = ({status}) => {

    const getCurrentStep = () => {
        if (status) {
            switch (status) {
                case 'Open' : return 1;
                case 'Processing' : return 2;
                case 'Request for Information' : return 3;
                case 'Closed' : return 4;
            }
        }
        return 1;
    }

    const stepClass = (step) => {
        let currStep = getCurrentStep();
        if (step < currStep) {
            return 'step' + step + ' done';
        }
        else if (step === currStep) {
            return 'step' + step + ' done active';
        }
        else {
            return 'step' + step;
        }
    }

    const stepLabel = (step) => {
        let currStep = getCurrentStep();
        if (currStep == step) {
            switch (currStep) {
                case 1:
                    return 'Open';
                case 2:
                    return 'Processing';
                case 3:
                    return 'Request for Info';
                case 4:
                    return 'Closed';
            }
        }
        return '';
    }

    return (
        <RequestTrackingStatusDiv>
            <div className='progressBar'>
                <div className='progressLine'>
                    <div className={ stepClass(1) }>{ stepLabel(1) }</div>
                    <div className={ stepClass(2) }>{ stepLabel(2) }</div>
                    <div className={ stepClass(3) }>{ stepLabel(3) }</div>
                    <div className={ stepClass(4) }>{ stepLabel(4) }</div>
                </div>
            </div>
        </RequestTrackingStatusDiv>
    );
};


export default RequestTrackingStatus;
